module.exports = __webpack_public_path__ + "img/login-image.72a75281.svg";